// MobileShell — шелл мобильной версии (<= 768px): CREW-хедер сверху,
// контент со скроллом, SHEET-таббар снизу. Те же роуты/URL, что и на
// десктопе — разметка внутри страниц адаптируется отдельно.
// Баланс — тот же live-канал, что в AppHeader (wallet:{address}).
// TODO(sheets): bell/wallet/profile пока инертны — поповеры десктопные,
// переводим на bottom sheets отдельной задачей.

import { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { formatTon, useLiveWalletBalance } from '../../hooks/useLiveWalletBalance'
import { accountAvatarSrc } from '../../lib/profileIdentity'
import { useAccountSession } from '../../wallet/AccountSessionContext'
import { useAuthShell } from '../../wallet/AuthShellContext'
import { useOptionalTradingSession } from '../../wallet/TradingSessionContext'
import { useActiveWallet } from '../../wallet/WalletsContext'
import { useGuestTradePrompt } from '../../wallet/guestTradePrompt'
import { TRADE_AUTH_REQUIRED_EVENT, hasPendingIdentityConfirmation } from '../../wallet/tradeAuth'
import { SearchModal } from '../search/SearchModal'
import { MobileHeader } from './MobileHeader'
import { MobileScreenGlow } from './MobileScreenGlow'
import styles from './MobileShell.module.css'
import { MobileTabBar } from './MobileTabBar'

// те же правила активности, что у HeaderNav на десктопе
const TAB_MATCH: ReadonlyArray<{ label: string; match: (p: string) => boolean }> = [
  {
    label: 'Discover',
    match: (p) => p.startsWith('/discover') || p.startsWith('/pair') || p.startsWith('/tokens'),
  },
  { label: 'Trenches', match: (p) => p.startsWith('/pulse') },
  { label: 'Portfolio', match: (p) => p.startsWith('/portfolio') },
  { label: 'Rewards', match: (p) => p.startsWith('/rewards') },
]

export function MobileShell() {
  const [searchOpen, setSearchOpen] = useState(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { status: accountStatus, me } = useAccountSession()
  const { openAuth } = useAuthShell()
  const { prompt: promptGuestTrade } = useGuestTradePrompt()
  const guest = accountStatus === 'guest'
  useEffect(() => {
    const onAuth = () => {
      if (guest) promptGuestTrade()
      else if (hasPendingIdentityConfirmation()) openAuth('confirm')
    }
    window.addEventListener(TRADE_AUTH_REQUIRED_EVENT, onAuth)
    return () => window.removeEventListener(TRADE_AUTH_REQUIRED_EVENT, onAuth)
  }, [guest, openAuth, promptGuestTrade])
  const activeWallet = useActiveWallet()
  const trading = useOptionalTradingSession()
  const fallback = useLiveWalletBalance(activeWallet?.address ?? null)
  const balanceNano =
    trading?.selectedBalanceNano ?? trading?.liveBalance.balanceNano ?? fallback.balanceNano

  const active = TAB_MATCH.find((t) => t.match(pathname))?.label ?? 'Discover'
  // Страница токена: шелл-хром убран — своя липкая шапка + трейд-панель
  // внизу (журнал wils-design 2026-07-27). Разделы — четыре корневых пути.
  const SECTION_PATHS = ['/discover', '/pulse', '/portfolio', '/rewards']
  const chromeless = !SECTION_PATHS.some((prefix) => pathname.startsWith(prefix))
  const avatarLetter = (activeWallet?.label ?? 'K').trim().charAt(0).toUpperCase() || 'K'

  return (
    <div className={styles.shell}>
      <MobileScreenGlow />
      {!chromeless && <div className={styles.horizon} aria-hidden="true" />}
      {!chromeless && (
        <MobileHeader
          variant="handoff"
          balance={guest ? '0' : formatTon(balanceNano)}
          avatarLetter={guest ? '' : avatarLetter}
          avatarSrc={guest ? null : accountAvatarSrc(me)}
          onSearch={() => setSearchOpen(true)}
          onLogin={guest ? () => openAuth('chooser') : undefined}
        />
      )}
      <main className={styles.content} data-chromeless={chromeless || undefined}>
        <Outlet />
      </main>
      {!chromeless && (
        <div className={styles.tabbarSlot}>
          <MobileTabBar variant="blob" active={active} onNavigate={(to) => navigate(to)} />
        </div>
      )}
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  )
}
